import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators, FormArray, FormBuilder } from '@angular/forms';
import { DataService } from '../data.service';

import {MAT_MOMENT_DATE_FORMATS, MomentDateAdapter} from '@angular/material-moment-adapter';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import * as moment from 'moment';

import * as pdfMake from 'pdfmake/build/pdfmake.js';
import * as pdfFonts from 'pdfmake/build/vfs_fonts.js';

pdfMake.vfs = pdfFonts.pdfMake.vfs;
pdfMake.fonts = {
  Roboto: {
    normal: 'Roboto-Regular.ttf',
    bold: 'Roboto-Medium.ttf',
  	italics: 'Roboto-Italic.ttf',
  	bolditalics: 'Roboto-MediumItalic.ttf' 
	},
  Cour: {
    normal: 'CourierPrime-Regular.ttf',
    bold: 'CourierPrime-Bold.ttf',
    italics: 'CourierPrime-Italic.ttf',
    bolditalics: 'CourierPrime-BoldItalic.ttf'
  }
}

export const MY_FORMATS = {
  parse: {
    dateInput: 'L', 
  },
  display: {
    dateInput: 'L',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMM YYYY',
  },
};

@Component({
  selector: 'app-tienda',
  templateUrl: './tienda.component.html',
  styleUrls: ['./tienda.component.css'],
  providers: [
    {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
    {provide: MAT_DATE_LOCALE, useValue: "es-MX" },
  ] 
})
export class TiendaComponent implements OnInit {
  errMsg:string = "";
  okMsg:string = "";
  tiempoMsg:number = 3100;
  loading:boolean=false;
  item:any=[];
  forms:any=[];
  origenes:any=[];
  idOrigen:number = -1;
  
  idForm1:number = -1;
  idForm2:number = -1;
  idForm3:number = -1;
  
  qty1:number = 1;
  qty2:number = 1;
  qty3:number = 1;
  
  total:number = 0;
  
  fecEmi:string="";
  horaEmi:string="";
  formato:any=[];
  formStyle:any[];
  elemImp:any[];
  elemStyle:any[]=[]  
  dd:any;
  consolidaImp:boolean=false;
  generaRecibo:boolean=false;
  result:any;
  corte:string="";
  abrirDescargarPDF:number=-1;
  esFechaEspecial:boolean=false;
  fechaEspecial:any=[];

  thisForm = new FormGroup({
    qty1: new FormControl(this.item.qty1, [Validators.required]),
    prod1: new FormControl(this.item.prod1, [Validators.required]),
    form1: new FormControl(this.item.form1, [Validators.required]),
    importe1: new FormControl(this.item.importe1, [Validators.required]),
    ref1: new FormControl(this.item.ref1, []),
    qty2: new FormControl(this.item.qty2, [Validators.required]),
    prod2: new FormControl(this.item.prod2, [Validators.required]),
    form2: new FormControl(this.item.form2, [Validators.required]),
    importe2: new FormControl(this.item.importe2, [Validators.required]),
    ref2: new FormControl(this.item.ref2, []),
  });
  
  constructor(private dataService: DataService) { }

  ngOnInit() {
    this.thisForm.controls["qty1"].setValue(1);
    this.idForm1 = 11;   //--> Efectivo = 11
    this.thisForm.controls["form1"].setValue(this.idForm1);
    this.dataService.getVars("PDF_O-D").subscribe(
                      rows => {   
                              this.abrirDescargarPDF = <any>rows
                              },          
                      error => this.errMsg = <any>error,
                      () => this.fnPDF_Abrir_Descargar_Obtenido());
    this.dataService.getVars("FEC-TIC").subscribe(
                      rows => {   
                              this.esFechaEspecial = <any>rows
                              },          
                      error => this.errMsg = <any>error,
                      () => this.fnFechaEspecialObtenida());
    this.dataService.getOrigenes('1').subscribe(
                      rows => {   
                              this.origenes = <any>rows
                              },          
                      error => this.errMsg = <any>error,
                      () => this.fnOrigenesCargados());

    this.dataService.getFormatoImp(1, 1).subscribe(
                      rows => {   
                              this.formato = <any>rows
                              },          
                      error => this.errMsg = <any>error,
                      () => this.fnFormatoImpCargado());

    this.dataService.getFormAct().subscribe(
                      rows => {   
                              this.forms = <any>rows
                              },          
                      error => this.errMsg = <any>error,
                      () => this.fnFormasCargadas());

  }

  fnOrigenesCargados(){
    console.log(this.origenes);
  }

  fnPDF_Abrir_Descargar_Obtenido(){
    //console.log(this.abrirDescargarPDF);
  }

  fnFechaEspecialObtenida(){
    //console.log(this.esFechaEspecial);
    if(this.esFechaEspecial){
      this.dataService.getFechaEspecial().subscribe(
                      rows => {   
                              this.fechaEspecial = <any>rows
                              },          
                      error => this.errMsg = <any>error,
                      () => this.fnFechaEspecial());
    }
  }

  fnFechaEspecial(){
    //console.log(this.fechaEspecial);
    this.fechaEspecial = moment(this.fechaEspecial[0].fecha.substr(6,4) + "/" + this.fechaEspecial[0].fecha.substr(3,2) + "/" + this.fechaEspecial[0].fecha.substr(0,2)).format("DD/MM/YYYY");
    //console.log(this.fechaEspecial);
  }
  
  fnFormatoImpCargado(){
    //console.log("Formatos: ");
    //console.log(this.formato);
    var arrIdForms = [];
    for(var i = 0; i < this.formato.length; i++){
      arrIdForms.push(this.formato[i].id);
    }
    //--> Obtener styles
    this.dataService.getFormStyles(arrIdForms.join(","), "1,2").subscribe(
                rows => {   
                        this.formStyle = <any>rows
                        },          
                error => this.errMsg = <any>error,
                () => this.fnFormStyleCargado())
  }
  
  fnFormStyleCargado(){
    //console.log(this.formStyle)
    var arrStyles=[];
    for(var i = 0; i < this.formStyle.length; i++){
      arrStyles.push(this.formStyle[i].style);
    }
    arrStyles = arrStyles.filter(this.dataService.onlyUnique);        
    for(var i = 0; i < arrStyles.length; i++){
      this.elemStyle[arrStyles[i]] = {};
      for(var k = 0; k < this.formStyle.length; k++){
        if(arrStyles[i] == this.formStyle[k].style){
            var auxObj = Object.keys(this.elemStyle[arrStyles[i]]);
            //console.log("Keys of Object:");
            //console.log(auxObj);
            if(auxObj.length == 0)
              this.elemStyle[arrStyles[i]] = {[this.formStyle[k].key]:this.formStyle[k].valor} ;
            else
              this.elemStyle[arrStyles[i]][this.formStyle[k].key]   = this.formStyle[k].valor;
        }
      }
    }
    //console.log(this.elemStyle);
  }

  fnFormasCargadas(){
    //console.log(this.forms);    
  }

  fnKeyPress(t, e){
    this.errMsg="";
    //console.log("KeyPress")
    //console.log(e)
    if (!this.dataService.validKey(t,e)){
        this.errMsg="Caracter inválido!";
        setTimeout(() => {
            this.errMsg="";
        }, this.tiempoMsg); 
        return false;   
    }
    else
      return true;
  }

  fnKeyUp(t, e){
    //console.log(e);
  }

  onChange(idEl, item, tipo){
    //console.log("onChange: " + tipo)
    this.onClick(idEl,item,tipo);
  }

  onClick(idEl, item, tipo){
    //console.log(tipo);
    //console.log("onClick: " + idEl);
    //console.log(item);
    if(tipo=="FORM1"){
      this.idForm1 = idEl;
    }   
    if(tipo=="FORM2"){
      this.idForm2 = idEl;
    }   
    if(tipo=="FORM3"){
      this.idForm3 = idEl;
    }   

  }

  fnCalculaTotal(){
    var auxTot = 0;
    auxTot = this.thisForm.controls["importe"].value;
    this.total = auxTot;
  }


  fnCorte(){
    console.log("corte");
    var aux;
    aux = this.dataService.fnGetDateFormat(this.dataService.fnGetHoy(), 'D/M/Y');
    if(this.esFechaEspecial)
      aux = this.fechaEspecial;
    this.dataService.getCorte(aux).subscribe(
                                rows => {   
                                        this.corte = <any>rows
                                        },          
                                error => this.errMsg = <any>error,
                                () => this.fnCorteCargado());
  }

  fnCorteCargado(){
    console.log(this.corte);
    setTimeout(() => {
      this.corte = "";
    }, 3000);
  }s
}
